import { useEffect, useState } from "react";
import axios from "axios";
import img1 from '../images/reply.jpeg'
import loadIcon from '../images/loader2.webp';
function Query()
{
    const [query,setQuery]=useState([]);
    const [progress,setProgress]=useState(false);
    const [show,setShow]=useState(false);
    const [replyquery,setReplyQuery]=useState({id:0,query:"",reply:"",querydate:"",replydate:"",cname:"",mobile:""});
    const apiClient = axios.create({
        baseURL: process.env.REACT_APP_APIURL, // Replace with your API base URL
        headers: {
            'Content-Type': 'application/json',
            'Authorization':'Bearer '+localStorage.getItem("token")
        }
    });  
    async function loadQueries()
    {
        setProgress(true);
        await apiClient.get(process.env.REACT_APP_APIURL+"/api/query/GetAllQueries").then(res=>
        {
            if(res.status==200)
            {
                setQuery(res.data.data);                                
            }
        });               
        setProgress(false);
    }
    function replytoquery(id)
    {
        let obj=query.find(e=>e.id==id);
        setReplyQuery(obj);
        setShow(true);
    }
    function formValueChanged(event)
    {
        if(event.target.id=="reply")
        {
            setReplyQuery({...replyquery,reply:event.target.value});
        }
    }
    async function saveData()
    {
        if(window.confirm('Are you sure?'))
        {
            await apiClient.post(process.env.REACT_APP_APIURL+"/api/query/SaveReply",replyquery).then(res=>
            {
                if(res.status==200 && res.data.status=="OK")
                {
                    setShow(false);
                    setReplyQuery({id:0,query:"",reply:"",querydate:"",replydate:"",cname:"",mobile:""});
                    loadQueries();
                }
                else
                {
                    alert("Some Error!!!");    
                }
            });               
            setProgress(false);
        }
    }
    useEffect(()=>{
        loadQueries();
    },[]);
    return(
        <div>
            <div>Queries of Last 3 Months</div>
            <table className="table table-bordered table-striped" style={{fontSize:'12px'}}>
                <thead>
                    <tr>
                        <th>S.No.</th>
                        <th>Subscriber Name</th>
                        <th>Mobile No</th>
                        <th>Query Date</th>
                        <th>Query/ Problem</th>
                        <th>Reply Date</th>
                        <th>Reply</th>
                        <th></th>                        
                    </tr>
                </thead>
                <tbody>
                    {query.map((e,i)=>
                        <tr key={i}>
                            <td>{i+1}</td>
                            <td>{e.cname}</td>
                            <td>{e.mobile}</td>
                            <td>{e.querydate.split("T")[0].split("-").reverse().join("-")}</td>
                            <td>{e.query}</td>
                            <td>{e.reply.trim()==""?"":e.replydate.split("T")[0].split("-").reverse().join("-")}</td>
                            <td>{e.reply}</td>
                            <td><img src={img1} style={{width:'30px',cursor:'pointer'}} onClick={()=>{replytoquery(e.id);}} /></td>
                        </tr>
                    )}
                </tbody>
            </table>
            {/*------------------------------------*/}
            {show && (
                    <div className="modal show d-block shadow modal-backdrop-custom"  tabIndex="-1">
                        <div className="modal-dialog modal-dialog-centered modal-md" >
                            <div className="modal-content rounded" style={{border:'double 1px black',backgroundImage:"linear-gradient(#AAF0DE,#BABAFF)", boxShadow:'5px 3px gray'}}>
                                <div className="modal-body p-4">                                    
                                    <div className="text-end"><button className="btn btn-close" onClick={() => setShow(false)}></button></div>
                                    <div className="h5 text-center">Query Reply</div>
                                    <input type="text" id="id"  value={replyquery.id} className="form-control mt-2 d-none"/>
                                    <input type="text" id="cname"  value={replyquery.cname} className="form-control mt-2"/>
                                    <input type="text" id="mobile"  value={replyquery.mobile} className="form-control mt-2" />                                    
                                    <input type="text" id="querydate"  value={replyquery.querydate.split("T")[0].split("-").reverse().join("-")} className="form-control mt-2" />                                    
                                    <textarea id="query" onChange={formValueChanged} value={replyquery.query} className="form-control mt-2" >{replyquery.query}</textarea>
                                    <textarea type="text" id="reply" onChange={formValueChanged} value={replyquery.reply} className="form-control mt-2" placeholder="Query Reply" >{replyquery.reply}</textarea> 
                                    <input type="button" className="btn btn-danger mt-2" onClick={saveData} value="Save Reply" /> <span className="text-primary h6 ms-2"></span>
                                </div>                                
                            </div>
                        </div>
                    </div>
                )}
            {/*------------------------------------*/}
            {progress && (
                    <div className="modal show d-block shadow modal-backdrop-custom"  tabIndex="-1">
                        <div className="modal-dialog modal-dialog-centered modal-md">
                                <div className="modal-body p-4">                                                                                                                                                
                                    <img src={loadIcon} alt="" style={{position:'fixed',left:'50%',top:'45%',width:'50px'}}/>
                                </div>                                                            
                        </div>
                    </div>
                )}
        </div>
    );
}
export default Query;